/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Core (@accedo/xdk-core) 4.0.3
* 
*******************************************************************************/
const isPlainObject=function(t){if(!t||"object"!=typeof t||t.nodeType)return!1;if(t.constructor&&!t.hasOwnProperty("constructor")&&!t.constructor.prototype.hasOwnProperty("isPrototypeOf"))return!1;for(var r in t);return void 0===r||t.hasOwnProperty(r)};export default isPlainObject;